module.exports = __webpack_public_path__ + "media/images/recrutare/carousel/carousel_1-644ddc45d9ad04b0598da17b1688ba85.jpg";